import React, { useState, useEffect, useCallback } from 'react';
import styles from '../index.module.sass';
import Lottie from 'react-lottie';
import OnBoardingLayout from 'layout/onboarding';
import Button from 'components/button';
import lottieAnimation from 'lottie/enable-on-street-parking-auto-pay-lottie.json';
import { useLoginFlowContext, SET_ON_STREET_PARKING_AUTO_PAY_PASS_DIALOG } from '../use-login-flow';
import amplitude from 'service/amplitude';
import { useAppContext } from 'use-app';
import { concat, uniq } from 'lodash';
import ButtonDialog from 'components/button-dialog';

const EnableOnStreetParkingAutoPayPage = () => {
  const { state, dispatch, enableOnStreetParkingAutoPay, disableOnStreetParkingAutoPay } = useLoginFlowContext();
  const { state: appState } = useAppContext();
  const [supportCitiesCount, setSupportCitiesCount] = useState();

  useEffect(() => {
    amplitude.onStreetParkingAutoPay_pageview();
  }, []);

  const onAgree = () => {
    amplitude.onStreetParkingAutoPay_start_onClick();
    enableOnStreetParkingAutoPay();
  };

  const onPass = useCallback(() => {
    amplitude.onStreetParkingAutoPay_later_onClick();
    dispatch({ type: SET_ON_STREET_PARKING_AUTO_PAY_PASS_DIALOG, payload: true });
  }, [dispatch]);

  const onConfirm = useCallback(() => {
    amplitude.onStreetParkingAutoPay_dialog_enable_onClick();
    enableOnStreetParkingAutoPay();
    dispatch({ type: SET_ON_STREET_PARKING_AUTO_PAY_PASS_DIALOG, payload: false });
  }, [dispatch]); // eslint-disable-line

  const onDisable = () => {
    amplitude.onStreetParkingAutoPay_dialog_pass_onClick();
    disableOnStreetParkingAutoPay();
    dispatch({ type: SET_ON_STREET_PARKING_AUTO_PAY_PASS_DIALOG, payload: false });
  };

  useEffect(() => {
    if (state.onStreetParkingAutoPayPassDialog) {
      amplitude.onStreetParkingAutoPay_dialog_onOpen();
    }
  }, [state.onStreetParkingAutoPayPassDialog]);

  useEffect(() => {
    let autoPay = appState.bootstraps.autoPayStreetParkingBillsCities.map(x => x.id);
    let scan = appState.bootstraps.scanStreetParkingBillsCities.map(x => x.id);
    let search = appState.bootstraps.searchStreetParkingBillsCities.map(x => x.id);
    let counts = uniq(concat(autoPay, scan, search)).length;
    setSupportCitiesCount(counts);
  }, []); //eslint-disable-line

  return (
    <>
      <ButtonDialog
        isShow={state.onStreetParkingAutoPayPassDialog}
        horizonal
        title="確認不啟用路停自動繳？"
        items={[
          {
            theme: 'positive',
            content: '啟用自動繳',
            onClick: onConfirm,
          },
          {
            theme: 'cancel',
            content: '先不啟用',
            onClick: onDisable,
          },
        ]}
      >
        輕鬆開啟自動繳，您的停車單免跑超商繳費，不再忘記漏繳，自動付款即時通知。
      </ButtonDialog>

      <OnBoardingLayout className={styles['enable-on-street-parking-auto-pay']}>
        <div className={styles.top}>
          <ul className={styles.progress}>
            <li className={styles.active}>1</li>
            <li>2</li>
            <li>3</li>
          </ul>
          <div className={styles.title}>
            路邊停車自動繳
            <br />
            幫你省下更多時間
          </div>
          <div className={styles.desc}>
            一鍵開啟路邊停車自動繳，無需耗時跑超商、繳費單不見也無妨，全台 {supportCitiesCount}{' '}
            縣市自動查，付款即時通知！
          </div>
          <div className={styles.lottie}>
            <Lottie
              options={{
                autoplay: true,
                loop: false,
                animationData: lottieAnimation,
              }}
            />
          </div>
        </div>
        <div className={styles.bottom}>
          <Button theme="blue" block={true} loading={state.loading} onClick={onAgree}>
            立即啟用
          </Button>
          <Button theme="link" block={true} onClick={onPass}>
            稍後
          </Button>
        </div>
      </OnBoardingLayout>
    </>
  );
};

export default EnableOnStreetParkingAutoPayPage;
